import NavbarComponent from "./Navbar";

export default NavbarComponent;
